import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Culture as Desc } from './desk'
import { Culture as Mob } from './mob'

export const Culture: React.FC = () => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob /> : <Desc />
}
